<span class="custom-slider-container">
    <span class="slider-title-container">
        <mat-label *ngIf="deviceInput.displayText" class="text-contrast slider-title">
            {{deviceInput.displayText}}
        </mat-label>
        <mat-form-field *ngIf="inputFormControl" class="cl-device-number-input slider-text-input">
            <input
                matInput
                type="number"
                (blur)="onBlur()"
                [disableControl]="!deviceInput.isEnabled"
                class="text-contrast"
                [formControl]="inputFormControl"
                (change)="textboxChange($event)"
                step="{{deviceInput.isEnabled ? step : ''}}"
            />
        </mat-form-field>
        <span *ngIf="units" class="cl-device-input-units text-contrast">
            {{ units }}
        </span>
    </span>
    <div class="custom-slider">
        <div>
            <ngx-slider
                [ngClass]="{'ngx-slider-temperature': isTemperature, 'ngx-slider-heat': isHeat, 'ngx-slider-cool': isCool, 'ngx-slider-default': !isHeat && !isCool, 'slider-invalid': inputFormControl && inputFormControl.errors}"
                [(value)]="flooredValue"
                (userChangeEnd)="attemptSliderChange($event)"
                [options]="options"
            >
            </ngx-slider>
            <mat-slide-toggle
                *ngIf="false"
                (change)="toggleEditStep($event)"
                checked="{{editStep}}"
                matTooltip="Toggle decimal slider"
                matTooltipPosition="above"
            >
            </mat-slide-toggle>
        </div>
        <div *ngIf="inputFormControl && !inputFormControl.errors && editStep && flooredValue < deviceInput.maxValue">
            <ngx-slider
                [ngClass]="{'ngx-slider-temperature': isTemperature, 'ngx-slider-heat': isHeat, 'ngx-slider-cool': isCool, 'ngx-slider-default': !isHeat && !isCool}"
                [(value)]="decimalValue"
                (userChangeEnd)="attemptSliderDecimalChange($event)"
                [options]="stepOptions"
            >
            </ngx-slider>
        </div>
    </div>
</span>
